const HEADER_SELECTOR = '[data-scroll-header]';
const HIDDEN_CLASS = 'is-hidden';
const SHOW_THRESHOLD = 600;
const SHOW_AGAIN_OFFSET = 100;

function initScrollHeader() {
	const header = document.querySelector(HEADER_SELECTOR);
	if (!header) {
		return;
	}

	let lastKnownScrollY = window.scrollY;
	let ticking = false;
	let lastHideScrollY = window.scrollY;

	const updateHeaderOffset = () => {
		document.documentElement.style.setProperty('--header-offset', `${header.offsetHeight}px`);
	};

	const updateHeaderState = () => {
		const currentScrollY = window.scrollY;
		const isMenuOpen = document.body.classList.contains('mobilemenu-open');

		if (isMenuOpen) {
			header.classList.remove(HIDDEN_CLASS);
			lastKnownScrollY = currentScrollY;
			lastHideScrollY = currentScrollY;
			ticking = false;
			return;
		}

		if (currentScrollY <= SHOW_THRESHOLD) {
			header.classList.remove(HIDDEN_CLASS);
			lastHideScrollY = currentScrollY;
		} else if (currentScrollY > lastKnownScrollY) {
			header.classList.add(HIDDEN_CLASS);
			lastHideScrollY = currentScrollY;
		} else if (currentScrollY < lastKnownScrollY) {
			const scrolledUpDistance = lastHideScrollY - currentScrollY;
			if (scrolledUpDistance >= SHOW_AGAIN_OFFSET) {
				header.classList.remove(HIDDEN_CLASS);
				lastHideScrollY = currentScrollY;
			}
		}

		lastKnownScrollY = currentScrollY;
		ticking = false;
	};

	const requestTick = () => {
		if (!ticking) {
			window.requestAnimationFrame(updateHeaderState);
			ticking = true;
		}
	};

	const handleResize = () => {
		updateHeaderOffset();
		requestTick();
	};

	window.addEventListener('scroll', requestTick, { passive: true });
	window.addEventListener('resize', handleResize);
	window.addEventListener('orientationchange', handleResize);
	window.addEventListener('load', updateHeaderOffset);

	updateHeaderOffset();
	updateHeaderState();
}

document.addEventListener('DOMContentLoaded', initScrollHeader);
